import { Stack } from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import pubsub from '../../../../../modules/pubsub'
import { ICategory } from '../../../../../shared/types'
import Spreadsheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import AddProductCategoryForm from './forms/AddProductCategoryForm'
import ExportProductCategoriesForm from './forms/ExportProductCategoriesForm'
import PageHeader from './PageHeader'
import PageContent from './page_content'

export default function Main() {

    const [isExportModalOpen, setIsExportModalOpen] = useState(false)
    const [isAddModalOpen, setIsAddModalOpen] = useState(false)


    const handleOnHeaderBtnSecondaryClick =()=>{
        setIsExportModalOpen(isExportModalOpen ? false : true)
    }
    const handleOnHeaderBtnPrimaryClick =()=>{
        setIsAddModalOpen(isAddModalOpen ? false : true)
    }

    const handleOnExport = (data:ICategory[])=>{

        if(data.length <= 0){
            toast("Error: No shops were created within the range you selected",{
                position: "top-center",
                type: "error",
                hideProgressBar: true,
                theme: "dark",
            })
            return
        }

        const rows = ["Date created", "Name", "Gross profit", "Gross revenue", "Items in stock", "Cash in shop"]
        const cols:string[][] = [];

        data.forEach((category)=>{
            const arr = [new Date(category.created_at as Date).toDateString(), category.name, category.gross_profit.toString(), category.gross_revenue.toString()]
            cols.push(arr)
        })


        const aoa = [
            rows,
            ...cols
        ]

        Spreadsheet.aoaToSpreadSheet(aoa, "Category list")
        setIsExportModalOpen(false)
        
        
    }

    const handleOnNewCategoryAdded = ()=>{
        pubsub.trigger("category-list:changed")
        setIsAddModalOpen(false)
        toast("New product category added successfully.", {
            type: "success",
            theme: "dark",
            position: "top-center",
            hideProgressBar: true,
            autoClose: 5000
        })
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >

            <PageHeader onBtnPrimaryClick={handleOnHeaderBtnPrimaryClick} onBtnSecondaryClick={handleOnHeaderBtnSecondaryClick} />
            <PageContent/>

            {/* Export modal */}
            <Modal
                title="Export sales history"
                subtitle="Select time range to export data"
                visible={isExportModalOpen}
                setVisibility={setIsExportModalOpen}
            >
                <ExportProductCategoriesForm 
                    onDone={handleOnExport}
                    onFail={()=>{}}
                />
            </Modal>

            {/* Add Modal */}
            <Modal
                title="Add new product category"
                subtitle="Please complete the form to add product category"
                visible={isAddModalOpen}
                setVisibility={setIsAddModalOpen}
            >
                <AddProductCategoryForm 
                    onDone={handleOnNewCategoryAdded}
                    onFail={()=>{}}
                />
            </Modal>


        </Stack>
    )

}
